document.addEventListener('DOMContentLoaded', function () {
  var nav = document.getElementById('nav');
  if (!nav) return;

  var mq = window.matchMedia('(max-width: 62.5em)');
  var panel = null;
  var extraRatingHidden = false;
  var layoutFixed = false;
  var reorderCard = null;
  var nativeGreetingHidden = false;

  var i18n = {
    'www.fidello.nl': { loginCta: 'Inloggen of account aanmaken', accountCta: 'Mijn account', delivery: 'Voor 17:30 besteld = morgen in huis.', discount: 'Log in en ontvang 5% korting op het hele assortiment.', discountLoggedIn: 'Je 5% korting wordt automatisch toegepast bij het afrekenen.', rating: 'lees onze klantbeoordelingen', greeting: 'Hoi', lastOrder: 'Laatste bestelling', reorderCta: 'Opnieuw bestellen', reorderBusy: 'Bezig…', reorderDone: 'Toegevoegd!', reviewCta: 'Schrijf een review' },
    'www.fidello.be': { loginCta: 'Inloggen of account aanmaken', accountCta: 'Mijn account', delivery: 'Vandaag besteld = binnen 2 dagen in huis.', discount: 'Log in en ontvang 5% korting op het hele assortiment.', discountLoggedIn: 'Je 5% korting wordt automatisch toegepast bij het afrekenen.', rating: 'lees onze klantbeoordelingen', greeting: 'Hoi', lastOrder: 'Laatste bestelling', reorderCta: 'Opnieuw bestellen', reorderBusy: 'Bezig…', reorderDone: 'Toegevoegd!', reviewCta: 'Schrijf een review' },
    'www.fidello.de': { loginCta: 'Anmelden oder Konto erstellen', accountCta: 'Mein Konto', delivery: 'Heute bestellt = Lieferung in 2–3 Werktagen.', discount: 'Melden Sie sich an und erhalten Sie 5% Rabatt auf das gesamte Sortiment.', discountLoggedIn: 'Ihr 5% Rabatt wird automatisch an der Kasse angewendet.', rating: 'Lesen Sie unsere Kundenbewertungen', greeting: 'Hallo', lastOrder: 'Letzte Bestellung', reorderCta: 'Erneut bestellen', reorderBusy: 'Läuft…', reorderDone: 'Hinzugefügt!', reviewCta: 'Bewertung schreiben' },
    'www.fidello.at': { loginCta: 'Anmelden oder Konto erstellen', accountCta: 'Mein Konto', delivery: 'Heute bestellt = Lieferung in 2–4 Werktagen.', discount: 'Melden Sie sich an und erhalten Sie 5% Rabatt auf das gesamte Sortiment.', discountLoggedIn: 'Ihr 5% Rabatt wird automatisch an der Kasse angewendet.', rating: 'Lesen Sie unsere Kundenbewertungen', greeting: 'Hallo', lastOrder: 'Letzte Bestellung', reorderCta: 'Erneut bestellen', reorderBusy: 'Läuft…', reorderDone: 'Hinzugefügt!', reviewCta: 'Bewertung schreiben' },
    'www.fidello.lu': { loginCta: 'Anmelden oder Konto erstellen', accountCta: 'Mein Konto', delivery: 'Heute bestellt = Lieferung in 2–3 Werktagen.', discount: 'Melden Sie sich an und erhalten Sie 5% Rabatt auf das gesamte Sortiment.', discountLoggedIn: 'Ihr 5% Rabatt wird automatisch an der Kasse angewendet.', rating: 'Lesen Sie unsere Kundenbewertungen', greeting: 'Hallo', lastOrder: 'Letzte Bestellung', reorderCta: 'Erneut bestellen', reorderBusy: 'Läuft…', reorderDone: 'Hinzugefügt!', reviewCta: 'Bewertung schreiben' },
    'www.fidello.pl': { loginCta: 'Zaloguj się lub załóż konto', accountCta: 'Moje konto', delivery: 'Zamówione dzisiaj = dostawa w 1–3 dni robocze.', discount: 'Zaloguj się i otrzymaj 5% rabatu na cały asortyment.', discountLoggedIn: 'Twoja zniżka 5% zostanie automatycznie zastosowana przy kasie.', rating: 'przeczytaj opinie naszych klientów', greeting: 'Cześć', lastOrder: 'Ostatnie zamówienie', reorderCta: 'Zamów ponownie', reorderBusy: 'Trwa…', reorderDone: 'Dodano!', reviewCta: 'Napisz opinię' },
    'www.fidello.dk': { loginCta: 'Log ind eller opret konto', accountCta: 'Min konto', delivery: 'Bestilt i dag = levering på 2–3 hverdage.', discount: 'Log ind og få 5% rabat på hele sortimentet.', discountLoggedIn: 'Din 5% rabat anvendes automatisk ved kassen.', rating: 'læs vores kundeanmeldelser', greeting: 'Hej', lastOrder: 'Seneste ordre', reorderCta: 'Bestil igen', reorderBusy: 'Arbejder…', reorderDone: 'Tilføjet!', reviewCta: 'Skriv en anmeldelse' },
    'www.fidello.fi': { loginCta: 'Kirjaudu sisään tai luo tili', accountCta: 'Oma tili', delivery: 'Tilattu tänään = toimitus 2–3 arkipäivässä.', discount: 'Kirjaudu sisään ja saat 5% alennuksen koko valikoimasta.', discountLoggedIn: '5% alennuksesi käytetään automaattisesti kassalla.', rating: 'lue asiakasarvostelumme', greeting: 'Hei', lastOrder: 'Viimeisin tilaus', reorderCta: 'Tilaa uudelleen', reorderBusy: 'Käsitellään…', reorderDone: 'Lisätty!', reviewCta: 'Kirjoita arvostelu' },
    'www.fidellofrance.fr': { loginCta: 'Se connecter ou créer un compte', accountCta: 'Mon compte', delivery: 'Commandé aujourd\'hui = livraison en 2 à 4 jours ouvrables.', discount: 'Connectez-vous et bénéficiez de 5% de réduction sur tout l\'assortiment.', discountLoggedIn: 'Votre réduction de 5% sera appliquée automatiquement lors du paiement.', rating: 'lisez nos avis clients', greeting: 'Bonjour', lastOrder: 'Dernière commande', reorderCta: 'Commander à nouveau', reorderBusy: 'En cours…', reorderDone: 'Ajouté !', reviewCta: 'Laisser un avis' },
    'www.fidello.pt': { loginCta: 'Iniciar sessão ou criar conta', accountCta: 'A minha conta', delivery: 'Encomendado hoje = entrega em 3–4 dias úteis.', discount: 'Inicie sessão e receba 5% de desconto em todo o sortido.', discountLoggedIn: 'O seu desconto de 5% será aplicado automaticamente no checkout.', rating: 'leia as nossas avaliações de clientes', greeting: 'Olá', lastOrder: 'Última encomenda', reorderCta: 'Encomendar novamente', reorderBusy: 'A processar…', reorderDone: 'Adicionado!', reviewCta: 'Escrever uma avaliação' },
    'www.fidello.se': { loginCta: 'Logga in eller skapa konto', accountCta: 'Mitt konto', delivery: 'Beställt idag = leverans inom 3–4 arbetsdagar.', discount: 'Logga in och få 5% rabatt på hela sortimentet.', discountLoggedIn: 'Din 5% rabatt tillämpas automatiskt i kassan.', rating: 'läs våra kundrecensioner', greeting: 'Hej', lastOrder: 'Senaste beställning', reorderCta: 'Beställ igen', reorderBusy: 'Bearbetar…', reorderDone: 'Tillagd!', reviewCta: 'Skriv en recension' },
    'www.fidello.co.uk': { loginCta: 'Log in or create an account', accountCta: 'My account', delivery: null, discount: 'Log in and get 5% off the entire range.', discountLoggedIn: 'Your 5% discount will be applied automatically at checkout.', rating: 'read our customer reviews', greeting: 'Hi', lastOrder: 'Last order', reorderCta: 'Reorder', reorderBusy: 'Adding…', reorderDone: 'Added!', reviewCta: 'Write a review' },
    'www.fidello.us': { loginCta: 'Log in or create an account', accountCta: 'My account', delivery: null, discount: 'Log in and get 5% off the entire range.', discountLoggedIn: 'Your 5% discount will be applied automatically at checkout.', rating: 'read our customer reviews', greeting: 'Hi', lastOrder: 'Last order', reorderCta: 'Reorder', reorderBusy: 'Adding…', reorderDone: 'Added!', reviewCta: 'Write a review' }
  };

  function getContent() {
    var host = document.body.getAttribute('data-host') || window.location.hostname;
    return i18n[host] || i18n['www.fidello.nl'];
  }

  function buildPanel() {
    var isLoggedIn = document.body.getAttribute('data-customer-logged-in') === 'true';
    var loginHref = document.body.getAttribute('data-login-url') || '/account/login';
    var t = getContent();

    var discountText = isLoggedIn ? t.discountLoggedIn : t.discount;
    var uspHtml = '';
    if (t.delivery || discountText) {
      var deliveryHtml = t.delivery ? '<strong>' + t.delivery + '</strong> ' : '';
      uspHtml = '<div class="fidello-panel__usp">' + deliveryHtml + (discountText || '') + '</div>';
    }

    var accountHtml = isLoggedIn
      ? ''
      : '<a class="fidello-panel__account" href="' + loginHref + '">' +
          '<i aria-hidden="true" class="icon-user"></i>' +
          '<span>' + t.loginCta + '</span>' +
        '</a>';

    var el = document.createElement('div');
    el.className = 'fidello-panel';
    el.innerHTML =
      accountHtml +
      uspHtml +
      '<a class="fidello-panel__rating" href="https://judge.me/reviews/stores/fidello">' +
        '<span class="stars">★★★★☆</span> 4.7/5 – ' + t.rating +
      '</a>' +
      '<div class="fidello-panel__photo"><img src="https://cdn.shopify.com/s/files/1/0870/4186/8111/files/foto_mobile_2_fidello.png?v=1787646747" alt="Fidello huisdieren"></div>';
    return el;
  }

  function hideExtraRating() {
    if (extraRatingHidden) return;
    var links = nav.querySelectorAll('a[href="https://judge.me/reviews/stores/fidello"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.classList.contains('fidello-panel__rating')) continue;
      var li = a.closest('li');
      (li || a).classList.add('fidello-hide-mobile');
    }
    extraRatingHidden = true;
  }

  function hideNativeGreeting() {
    if (nativeGreetingHidden) return;
    var isLoggedIn = document.body.getAttribute('data-customer-logged-in') === 'true';
    var name = document.body.getAttribute('data-customer-name');
    if (!isLoggedIn || !name) return;
    var accountUrl = document.body.getAttribute('data-account-url');
    var links = nav.querySelectorAll('a[href="' + accountUrl + '"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.closest('.fidello-panel') || a.closest('.fidello-reorder')) continue;
      if (a.textContent.indexOf(name) === -1) continue;
      var li = a.closest('li');
      (li || a).classList.add('fidello-hide-mobile');
    }
    nativeGreetingHidden = true;
  }

  function fixVoordeelLayout() {
    if (layoutFixed) return;
    var mainList = nav.querySelector('ul[data-type="main-nav"]');
    if (!mainList) return;
    var link = mainList.querySelector(':scope > li > a[href="/collections/voordeelpakketten"]');
    if (link) {
      link.closest('li').classList.add('fidello-fullwidth-row');
    }
    layoutFixed = true;
  }

  function addSingleToCart(btn, item) {
    if (btn.disabled) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: item.variantId, quantity: item.quantity || 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        btn.classList.add('is-done');
        btn.textContent = '✓';
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var counts = document.querySelectorAll('#cart-count, #cart-count--m');
        counts.forEach(function (c) { c.textContent = cart.item_count; });
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-done');
          btn.textContent = '+';
        }, 1800);
      })
      .catch(function () {
        btn.disabled = false;
      });
  }

  function buildReorderCard() {
    var isLoggedIn = document.body.getAttribute('data-customer-logged-in') === 'true';
    if (!isLoggedIn) return null;

    var dataEl = document.getElementById('fidello-last-order-data');
    if (!dataEl) return null;
    var order;
    try {
      order = JSON.parse(dataEl.textContent);
    } catch (e) {
      return null;
    }
    if (!order || !order.items || !order.items.length) return null;

    var t = getContent();
    var name = document.body.getAttribute('data-customer-name') || '';
    var accountHref = document.body.getAttribute('data-account-url') || '/account';
    var isCarousel = order.items.length > 2;

    var card = document.createElement('div');
    card.className = 'fidello-reorder';

    var itemsWrap = document.createElement('div');
    itemsWrap.className = 'fidello-reorder__items';

    order.items.forEach(function (item) {
      var itemEl = document.createElement('div');
      itemEl.className = 'fidello-reorder__item';

      var photoEl = document.createElement('div');
      photoEl.className = 'fidello-reorder__item-photo';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        photoEl.appendChild(img);
      }
      var addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'fidello-reorder__additem';
      addBtn.setAttribute('aria-label', t.reorderCta);
      addBtn.textContent = '+';
      addBtn.addEventListener('click', function () { addSingleToCart(addBtn, item); });
      photoEl.appendChild(addBtn);
      itemEl.appendChild(photoEl);

      var titleEl = document.createElement('span');
      titleEl.className = 'fidello-reorder__item-title';
      titleEl.textContent = item.title + (item.quantity > 1 ? ' ×' + item.quantity : '');
      itemEl.appendChild(titleEl);

      if (item.productUrl) {
        var reviewLink = document.createElement('a');
        reviewLink.className = 'fidello-reorder__item-review';
        reviewLink.href = item.productUrl + '#judgeme_product_reviews';
        reviewLink.textContent = t.reviewCta;
        itemEl.appendChild(reviewLink);
      }

      itemsWrap.appendChild(itemEl);
    });

    var itemsHtml;
    if (isCarousel) {
      var carouselWrap = document.createElement('div');
      carouselWrap.className = 'fidello-reorder__carousel';
      var prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'fidello-reorder__arrow fidello-reorder__arrow--prev';
      prevBtn.setAttribute('aria-label', 'Vorige');
      prevBtn.textContent = '‹';
      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'fidello-reorder__arrow fidello-reorder__arrow--next';
      nextBtn.setAttribute('aria-label', 'Volgende');
      nextBtn.textContent = '›';
      prevBtn.addEventListener('click', function () {
        itemsWrap.scrollBy({ left: -106, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        itemsWrap.scrollBy({ left: 106, behavior: 'smooth' });
      });
      carouselWrap.appendChild(prevBtn);
      carouselWrap.appendChild(itemsWrap);
      carouselWrap.appendChild(nextBtn);
      itemsHtml = carouselWrap;
    } else {
      itemsHtml = itemsWrap;
    }

    var greetingEl = document.createElement('div');
    greetingEl.className = 'fidello-reorder__greeting';
    greetingEl.textContent = t.greeting + (name ? ', ' + name : '');
    card.appendChild(greetingEl);

    var labelEl = document.createElement('div');
    labelEl.className = 'fidello-reorder__label';
    labelEl.textContent = t.lastOrder + ': ' + order.name + ' (' + order.date + ')';
    card.appendChild(labelEl);

    card.appendChild(itemsHtml);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fidello-reorder__btn';
    btn.textContent = t.reorderCta;
    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.textContent = t.reorderBusy;
      var items = order.items
        .filter(function (item) { return item.variantId; })
        .map(function (item) { return { id: item.variantId, quantity: item.quantity || 1 }; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = t.reorderDone;
          window.location.href = '/cart';
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = t.reorderCta;
        });
    });
    card.appendChild(btn);

    var accountLink = document.createElement('a');
    accountLink.className = 'fidello-reorder__account';
    accountLink.href = accountHref;
    accountLink.innerHTML = '<i aria-hidden="true" class="icon-user"></i><span>' + t.accountCta + '</span>';
    card.appendChild(accountLink);

    return card;
  }

  function insertReorderCard() {
    if (reorderCard) return;
    var card = buildReorderCard();
    if (!card) return;
    nav.appendChild(card);
    reorderCard = card;
  }

  function sync(e) {
    var isMobile = e ? e.matches : mq.matches;
    if (isMobile) {
      if (!panel) {
        panel = buildPanel();
        var titleEl = nav.querySelector('.header');
        if (titleEl && titleEl.parentElement === nav) {
          titleEl.insertAdjacentElement('afterend', panel);
        } else {
          nav.insertBefore(panel, nav.firstChild);
        }
      }
      hideExtraRating();
      fixVoordeelLayout();
      insertReorderCard();
      hideNativeGreeting();
    } else if (panel) {
      panel.remove();
      panel = null;
    }
  }

  sync();
  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync);
  }
});
